const provincesList = [
  { id: "ab", label_en: "Alberta", label_fr: "Alberta" },
  { id: "bc", label_en: "British Columbia", label_fr: "Colombie-Britannique" },
  { id: "mb", label_en: "Manitoba", label_fr: "Manitoba" },
  { id: "nb", label_en: "New Brunswick", label_fr: "Nouveau-Brunswick" },
  { id: "nl", label_en: "Newfoundland and Labrador", label_fr: "Terre-Neuve-et-Labrador" },
  { id: "nt", label_en: "Northwest Territories", label_fr: "Territoires du Nord-Ouest" },
  { id: "ns", label_en: "Nova Scotia", label_fr: "Nouvelle-Écosse" },
  { id: "nu", label_en: "Nunavut", label_fr: "Nunavut" },
  { id: "pe", label_en: "Prince Edward Island", label_fr: "Île-du-Prince-Édouard" },
  { id: "on", label_en: "Ontario", label_fr: "Ontario" },
  { id: "qc", label_en: "Quebec", label_fr: "Québec" },
  { id: "sk", label_en: "Saskatchewan", label_fr: "Saskatchewan" },
  { id: "yt", label_en: "Yukon", label_fr: "Yukon" },
];

export default provincesList;